import { AdvancedMarker, Pin } from "@vis.gl/react-google-maps";
import { memo } from "react";
import { PIN_STYLES } from "./mapConstants";

const RouteMarker = memo(function RouteMarker({ position, variant, title }) {
  const pinStyle = variant === "origen" ? PIN_STYLES.origen : PIN_STYLES.destino;

  return (
    <AdvancedMarker position={position} title={title}>
      <Pin {...pinStyle} />
    </AdvancedMarker>
  );
});

export default RouteMarker;
